// this file is generated by update_shopify_store_data.py at 2026-11-03 20:14:07.529694
var courses = [
    {
        "course_id": "24D138C4-71C9-F011-99A1-005056A730AF",
        "course_version": 2,
        "name": "Springer Publishing - CNOR\u00ae Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Certified Perioperative Nurse (CNOR\u00ae) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nCNOR\u00ae is a registered trademark of the Competency and Credentialing Institute (CCI). The CCI does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and evidence-based practices related to perioperative nursing care and patient safety.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to intraoperative, preoperative, and postoperative patient-care scenarios.</li>\r\n    <li>Demonstrate readiness for the CNOR&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<li>Introduction</li>\r\n<li>Module 1: Certification Exam</li>\r\n<li>Module 2: Perioperative Patient Assessment and Nursing Diagnosis</li>\r\n<li>Module 3: Individualized Plan of Care and Expected Outcome Identification</li>\r\n<li>Module 4: Management of Intraoperative Activities&mdash;Patient Care and Safety</li>\r\n<li>Module 5: Management of Intraoperative Activities&mdash;Personnel, Services, and Materials</li>\r\n<li>Module 6: Communication and Documentation</li>\r\n<li>Module 7: Infection Prevention and Control of the Environment, Instruments, and Supplies</li>\r\n<li>Module 8: Emergency Situations and Patient and Personnel Safety</li>\r\n<li>Module 9: Professional Accountabilities</li>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3D3623AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Perioperative Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4B8CE4E2-D6C9-E511-82AF-005056B150D3",
                "course_category_name": "Medical Equipment",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];